module.exports = __webpack_public_path__ + "static/media/white_bg-signout.9027140b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_bg-signout.svg
// module id = 267
// module chunks = 0